<template>
  <PurchaseSell />
</template>

<script>
import PurchaseSell from "./movement/purchasesell.vue";

export default {
  name: "MenuPurchaseSell",

  components: {
    PurchaseSell,
  },
};
</script>